module.exports = __webpack_public_path__ + "images/store_case_study/belmond-pic1_04b2e7158da0ff8142e6a20f0b78b56b.jpg";